module.exports = __webpack_public_path__ + "ab0d7f8062df2844c74ca8a03c3945a0.png";